/**
 * sidebar.js — サイドバーの開閉制御 (material-dashboard.js のサイドバー処理の置換)
 *
 *  - モバイル (< lg): トグルでオフキャンバスを開閉。スクリム/Esc/リンク遷移で閉じる。
 *  - デスクトップ (>= lg): トグルで 72px 折りたたみ。状態は localStorage に保存。
 *
 * マークアップ契約:
 *   .l-shell[data-shell]
 *     [data-sidebar-toggle]        … 切替ボタン (トップバー)
 *     [data-sidebar-close]         … 閉じるトリガ (スクリム等)
 *     .l-sidebar / .l-sidebar__link
 */
const DESKTOP_MQ = '(min-width: 992px)';
const STORAGE_KEY = 'aroma.sidebarCollapsed';

export function initSidebar() {
  const shell = document.querySelector('[data-shell]');
  if (!shell) return;

  const mq = window.matchMedia(DESKTOP_MQ);

  // デスクトップの折りたたみ状態を復元
  if (localStorage.getItem(STORAGE_KEY) === '1') {
    shell.classList.add('is-sidebar-collapsed');
  }

  const openMobile = () => shell.classList.add('is-sidebar-open');
  const closeMobile = () => shell.classList.remove('is-sidebar-open');
  const toggleCollapse = () => {
    const collapsed = shell.classList.toggle('is-sidebar-collapsed');
    localStorage.setItem(STORAGE_KEY, collapsed ? '1' : '0');
  };

  shell.querySelectorAll('[data-sidebar-toggle]').forEach((btn) => {
    btn.addEventListener('click', () => {
      if (mq.matches) {
        toggleCollapse();
      } else if (shell.classList.contains('is-sidebar-open')) {
        closeMobile();
      } else {
        openMobile();
      }
    });
  });

  // スクリムなどの閉じるトリガ
  shell.querySelectorAll('[data-sidebar-close]').forEach((el) => {
    el.addEventListener('click', closeMobile);
  });

  // Esc でモバイルサイドバーを閉じる
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') closeMobile();
  });

  // モバイルでリンクをタップしたら閉じる
  const sidebar = shell.querySelector('.l-sidebar');
  if (sidebar) {
    sidebar.addEventListener('click', (e) => {
      if (!mq.matches && e.target.closest('.l-sidebar__link')) {
        closeMobile();
      }
    });
  }

  // デスクトップ↔モバイルをまたいだらオフキャンバス状態をリセット
  const onChange = () => closeMobile();
  if (typeof mq.addEventListener === 'function') {
    mq.addEventListener('change', onChange);
  } else if (typeof mq.addListener === 'function') {
    mq.addListener(onChange); // 古い Safari 向けフォールバック
  }
}
